// ===== Action Types =====
export const SET_ACTIVE_CHANNEL = 'SET_ACTIVE_CHANNEL';
export const DISABLE_ALL_CHANNELS = 'DISABLE_ALL_CHANNELS';
export const SWITCH_CHANNEL = 'SWITCH_CHANNEL';
export const START_TALKING = 'START_TALKING';
export const STOP_TALKING = 'STOP_TALKING';
export const START_LISTENING = 'START_LISTENING';
export const STOP_LISTENING = 'STOP_LISTENING';
export const START_CHANNEL_TIMER = 'START_CHANNEL_TIMER';
export const RESET_CHANNEL_TIMER = 'RESET_CHANNEL_TIMER';
export const STOP_CHANNEL_TIMER = 'STOP_CHANNEL_TIMER';
export const CHANNEL_TIMEOUT = 'CHANNEL_TIMEOUT';

// ===== Action Interfaces =====
interface SetActiveChannelAction {
  type: typeof SET_ACTIVE_CHANNEL;
  payload: {
    sentinelId: number;
    activatedBy: 'alarm' | 'manual';
  };
}

interface DisableAllChannelsAction {
  type: typeof DISABLE_ALL_CHANNELS;
}

interface SwitchChannelAction {
  type: typeof SWITCH_CHANNEL;
  payload: {
    fromSentinelId: number;
    toSentinelId: number;
    activatedBy: 'alarm' | 'manual';
  };
}

interface StartTalkingAction {
  type: typeof START_TALKING;
}

interface StopTalkingAction {
  type: typeof STOP_TALKING;
}

interface StartListeningAction {
  type: typeof START_LISTENING;
}

interface StopListeningAction {
  type: typeof STOP_LISTENING;
}

interface StartChannelTimerAction {
  type: typeof START_CHANNEL_TIMER;
  payload: number; // timerHandle
}

interface ResetChannelTimerAction {
  type: typeof RESET_CHANNEL_TIMER;
}

interface StopChannelTimerAction {
  type: typeof STOP_CHANNEL_TIMER;
}

interface ChannelTimeoutAction {
  type: typeof CHANNEL_TIMEOUT;
}

export type WalkieTalkieAction =
  | SetActiveChannelAction
  | DisableAllChannelsAction
  | SwitchChannelAction
  | StartTalkingAction
  | StopTalkingAction
  | StartListeningAction
  | StopListeningAction
  | StartChannelTimerAction
  | ResetChannelTimerAction
  | StopChannelTimerAction
  | ChannelTimeoutAction;

// ===== Action Creators =====

/**
 * Attiva un canale audio su un letto specifico
 */
const setActiveChannel = (
  sentinelId: number,
  activatedBy: 'alarm' | 'manual'
): SetActiveChannelAction => {
  return {
    type: SET_ACTIVE_CHANNEL,
    payload: { sentinelId, activatedBy },
  };
};

/**
 * Disabilita tutti i canali audio
 */
const disableAllChannels = (): DisableAllChannelsAction => {
  return { type: DISABLE_ALL_CHANNELS };
};

/**
 * Switcha canale da un letto a un altro
 */
const switchChannel = (
  fromSentinelId: number,
  toSentinelId: number,
  activatedBy: 'alarm' | 'manual' = 'manual'
): SwitchChannelAction => {
  return {
    type: SWITCH_CHANNEL,
    payload: { fromSentinelId, toSentinelId, activatedBy },
  };
};

/**
 * Inizia trasmissione (pulsante TALK premuto)
 */
const startTalking = (): StartTalkingAction => {
  return { type: START_TALKING };
};

/**
 * Termina trasmissione (pulsante TALK rilasciato)
 */
const stopTalking = (): StopTalkingAction => {
  return { type: STOP_TALKING };
};

/**
 * Inizia ascolto
 */
const startListening = (): StartListeningAction => {
  return { type: START_LISTENING };
};

/**
 * Termina ascolto
 */
const stopListening = (): StopListeningAction => {
  return { type: STOP_LISTENING };
};

/**
 * Avvia timer timeout canale
 */
const startChannelTimer = (timerHandle: number): StartChannelTimerAction => {
  return { type: START_CHANNEL_TIMER, payload: timerHandle };
};

/**
 * Resetta timer timeout canale
 */
const resetChannelTimer = (): ResetChannelTimerAction => {
  return { type: RESET_CHANNEL_TIMER };
};

/**
 * Ferma timer timeout canale
 */
const stopChannelTimer = (): StopChannelTimerAction => {
  return { type: STOP_CHANNEL_TIMER };
};

/**
 * Timer scaduto - spegne canale automaticamente
 */
const channelTimeout = (): ChannelTimeoutAction => {
  return { type: CHANNEL_TIMEOUT };
};

export const WalkieTalkieActions = {
  setActiveChannel,
  disableAllChannels,
  switchChannel,
  startTalking,
  stopTalking,
  startListening,
  stopListening,
  startChannelTimer,
  resetChannelTimer,
  stopChannelTimer,
  channelTimeout,
};
